import axios from 'axios';
import API_URL from './api';

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Add response interceptor to handle authentication errors globally
axiosInstance.interceptors.response.use(
  (response) => {
        console.log('✅ API Response:', response.config.url, response.status);
    return response;
  },
  (error) => {
      console.error('❌ API Error:', error.config?.url, error.response?.status, error.response?.data);

    // Check if error is 401 (Unauthorized) or 403 (Forbidden) with invalid token message
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      const message = error.response.data?.message || '';
      
        console.error('🚨 AUTH ERROR DETECTED:', {
            status: error.response.status,
            message: message,
            url: error.config?.url
        });

      // If token is invalid or user not found, clear storage and redirect to login
      if (
        message.includes('Invalid token') ||
        message.includes('Access token required') ||
          message.includes('User not found') ||
        error.response.status === 401
      ) {
          console.error('🔴 FORCING LOGOUT - User does not exist in database');

        // Clear all authentication data
          localStorage.clear();
        sessionStorage.clear();
        
          // Force hard redirect to login
          setTimeout(() => {
              window.location.replace('/auth/login');
          }, 100);
      }
    }
    
    return Promise.reject(error);
  }
);

// Add request interceptor to include token in all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
        console.log('📤 API Request:', config.url, token ? 'Token present' : 'No token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
